var render = function render(){var _vm=this,_c=_vm._self._c;return _c('surroundBox',{attrs:{"name":_vm.description,"desc":"自动化、智能化、信息化的程度"}},[_c('template',{slot:"content"},[_c('div',{staticClass:"informationLevel-echart",staticStyle:{"width":"100%","height":"100%"}})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }